// extracted by mini-css-extract-plugin
export var col = "style-module--col--ee404";
export var name = "style-module--name--a7c97";
export var photosRow = "style-module--photos-row--4099e";
export var reviews = "style-module--reviews--23f32";
export var row = "style-module--row--89bd8";
export var title = "style-module--title--af9d7";
export var video = "style-module--video--dc911";
export var wrap = "style-module--wrap--09e1a";